import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "info-box__content" }
const _hoisted_2 = { key: 0 }


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBox',
  props: {
    text: {},
    strongText: {},
    slim: { type: Boolean },
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["info-box", {'info-box--slim': __props.slim}])
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["icon", `icon--${__props.icon}`])
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_1, [
      (__props.strongText)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(__props.strongText), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (__props.text)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["info-box__text", {'info-box__text--secondary': __props.strongText}])
          }, _toDisplayString(__props.text), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})